import { SkeletonGroup } from "./SkeletonGroup";
import { SkeletonItem } from "./SkeletonItem";

export const Skeleton = {
  Group: SkeletonGroup,
  Skeleton: SkeletonItem,
};
